import openModal from './openModal';
import resetForm from './resetForm';

export default () => (dispatch) => {
    dispatch(openModal(false));
    dispatch(resetForm());
};
